module.exports = __webpack_public_path__ + "img/copy-to-clipboard.0d909c3c.svg";